import Vuex from 'vuex';
import Lots from "./services/Lots";
import User from "./services/user";
import jwt_decode from "jwt-decode";
import router from './router/router';
import Public from "./services/Public";
import Allotments from "./services/Allotments";
import {http, httpAuth, httpCustom} from './services/config';
import ConfigClickSign from './services/ConfigClickSign';
import reserve from './store/modules/reserve/index';
import publicClient from './store/modules/publicClient/index';

const stores = new Vuex.Store({
    modules:{
        reserve,
        publicClient,
    },
    state: {
        itemsValidations: [],
        darkTheme: localStorage.getItem('darkTheme'),
        itemsValidationsRequired: [],
        image: null,
        minutesForExpiration: null,
        pinned: false,
        toggled: null,
        companies: [],
        loopLots: null,
        sale: null,
        isLoading: null,
        isCompany: null,
        allotments: null,
        allotmentsOnlyUserAllo: null,
        showModal: false,
        oneToExpire: null,
        selectedClients: null,
        lotModified: null,
        fiveToExpire: null,
        imageCropped: null,
        allotmentLoad: null,
        hasAllotments: null,
        intervalTokenCustom: null,
        expirationTime: null,
        disableBeforeOne: null,
        hastwoAllotments: null,
        disableBeforeFive: null,
        savedMoviments: null,
        showReahtorizationAlert: false,
        dateNow: null,
        menssageAllotmentRequired: false,
        itemId: null,
        paginate: [
            {id: 'selecione', text: 'Selecione'},
            {id: 25, text: 25},
            {id: 50, text: 50},
            {id: 75, text: 75},
            {id: 100, text: 100},
        ],
        hasConfigClickSign: false,
    },
    actions: {
        actionTimeoutRefreshTokenCustom({state})
        {
            clearInterval(state.intervalTokenCustom);
            if (sessionStorage.getItem('refresh_token_custom') && localStorage.getItem('access_token')){
                state.intervalTokenCustom = setInterval(() => {
                    let refresh = sessionStorage.getItem('refresh_token_custom');
                    let token = sessionStorage.getItem('access_token_custom');
                    if (!refresh || !token || !localStorage.getItem('access_token')) {
                        clearInterval(state.intervalTokenCustom);
                    }else{
                        let currentTime = new Date().getTime() / 1000.0;
                        let expirationTime = jwt_decode(token).exp;
                        let expirationTimeFive = new Date(expirationTime * 1000);
                        expirationTimeFive.setMinutes(expirationTimeFive.getMinutes() - 5)
                        expirationTimeFive = expirationTimeFive.getTime() / 1000;
                        if (currentTime > expirationTimeFive){
                            User.refreshTokenCustom(refresh).then(resp => {
                                if (resp?.data){
                                    let scopeRef = jwt_decode(resp.data.accessToken).scope_ref;
                                    if (scopeRef){
                                        sessionStorage.setItem('access_token_custom', resp.data.accessToken);
                                        sessionStorage.setItem('refresh_token_custom', resp.data.refreshToken);
                                        sessionStorage.setItem('allotmentIdScope', scopeRef);
                                        httpCustom.defaults.headers.authorization = `Bearer ${resp.data.accessToken}`;
                                        httpCustom.defaults.headers.common['company-id'] = localStorage.getItem('companyId');
                                    }
                                }
                            });
                        }else  if (currentTime > expirationTime) {
                            sessionStorage.removeItem('access_token_custom');
                            sessionStorage.removeItem('refresh_token_custom');
                            sessionStorage.removeItem('allotmentIdScope');
                        }
                    }
                },100000);
            }
        },
        getHasConfigClickSign({state}){
            ConfigClickSign.index().then(resp => {
                state.hasConfigClickSign = !!resp.data?.data?.length;
            }).catch(() => {
                state.hasConfigClickSign = false;
            })
        },
        async ActionLoadSession({dispatch}) {
            await User.loadSession().then((resp) => {
                if (resp.data.length !== 0){
                    dispatch('ActionSingOut')
                    router.push({name: 'Login'});
                }
            }).catch(() => {
                dispatch('ActionSingOut')
                router.push({name: 'Login'});
            });
        },

        ActionSingOut({commit, state}) {
            setBearerToken('')
            commit('stopLopLots');
            commit('checkAllotments', false);
            localStorage.removeItem('companyId');
            localStorage.removeItem('companies');
            localStorage.removeItem('allotmentId');
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.removeItem('access_token_custom');
            sessionStorage.removeItem('refresh_token_custom');
            localStorage.removeItem('user');
            localStorage.removeItem('userAllotmentId');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('firstProfileClosed');
            localStorage.removeItem('disable_before_one');
            localStorage.removeItem('disable_before_five');
            clearInterval(state.intervalTokenCustom);
        },

        ActionCheckToken({dispatch}) {
            const access_token = localStorage.getItem('access_token');
            if (!access_token) {
                return Promise.reject(new Error('Token inválido'));
            }
            setBearerToken(access_token);
            return dispatch('ActionLoadSession');
        },

        ActionDoLogin({dispatch}, payload) {
            setBearerToken(payload.access_token);
            localStorage.setItem('access_token', payload.access_token);
            localStorage.setItem('refresh_token', payload.refreshToken);
            localStorage.setItem('companies', JSON.stringify(payload.companies));
            localStorage.setItem('user', JSON.stringify(payload.user));
            dispatch('ActionLoadSession');
        },
        async ActionDoLoginSecurity({dispatch}, payload) {
            setBearerToken(payload.accessToken);
            localStorage.setItem('access_token', payload.accessToken);
            localStorage.setItem('refresh_token', payload.refreshToken);
            payload?.companies ? localStorage.setItem('companies', JSON.stringify(payload.companies)) : '';
            if (!localStorage.getItem('user')) localStorage.setItem('user', JSON.stringify({
                id: payload.id, email: payload.login, name: payload.nome,
                avatar: payload?.avatar
            }));
            localStorage.setItem('companyId', payload.companyId);
           await dispatch('ActionLoadSession');
        },
        async ActionRefreshToken({dispatch, commit}) {
            await User.refreshToken(localStorage.getItem('refresh_token')).then(resp => {
                setBearerToken('');
                localStorage.removeItem('allotmentId');
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('firstProfileClosed');
                localStorage.removeItem('disable_before_one');
                localStorage.removeItem('disable_before_five');
                resp.data.companies = JSON.parse(localStorage.getItem('companies'));
                resp.data.user = JSON.parse(localStorage.getItem('user'));
                resp.data.user.id = resp.data.id;
                resp.data.user.name = resp.data.nome;
                resp.data.user.email = resp.data.login;
                resp.data.access_token = resp.data.accessToken;
                resp.data.refresh_token = resp.data.refreshToken;
                dispatch('ActionDoLogin', resp.data);
                commit('resetExpirationTime');
                commit('enableReauthorization', false);
            });
            dispatch('ActionRefreshTokenTime');
        },

        ActionDateNow({commit}) {
            setInterval(() => {
                let dateString = new Date().toLocaleString("pt-BR", {timeZone: "America/Sao_Paulo"});
                dateString = dateString.split('/')
                commit('DateNow', (`${dateString[0]}/${dateString[1]}/${dateString[2]}`));
            }, 1000);
        },
        getMinutesExpire({state,commit})
        {
            let currentTime = new Date().getTime() / 1000.0;
            let diff = state.expirationTime - currentTime;
            diff = diff /60;
            commit('changeMinutesForExpiration', diff.toFixed(0))
        },
        ActionRefreshTokenTime({dispatch, state, commit}) {
            commit('resetExpirationTime');
            commit('disbleModalBeforeOne');
            commit('disbleModalBeforeFive');
            commit('enableReauthorization', false);
            let intervalo = setInterval(() => {
                let currentTime = new Date().getTime() / 1000.0;
                if (currentTime > state.expirationTime) {
                    clearInterval(intervalo);
                    dispatch('ActionLoadSession');
                    commit('enableReauthorization', false);
                } else {
                    dispatch('getMinutesExpire');
                    if (currentTime > state.fiveToExpire && !state.disableBeforeFive) {
                        localStorage.setItem('disable_before_five', currentTime > state.fiveToExpire);
                        commit('enableReauthorization', 5);
                        commit('disbleModalBeforeFive');
                    } else if (currentTime > state.oneToExpire && !state.disableBeforeOne) {
                        localStorage.setItem('disable_before_one', currentTime > state.oneToExpire);
                        commit('enableReauthorization', 1);
                        commit('disbleModalBeforeOne');
                    } else {
                        commit('enableReauthorization', 2);
                    }
                }
            }, 30000);
        },

        ActionListLotModified({commit}, stop = false) {
            if (stop) {
                commit('stopLopLots');
            } else {
                commit('startLopLots');
            }
        },

        ActionSelectedClients({commit}, payload) {
            commit('selectedClients', payload);
        },

        ActionListLotModifiedPublic({commit}, companyId) {
            commit('startLopLots', companyId);
        },

        ActionAlterSaleValue({commit}, value) {
            commit('alterSaleValue', value);
        },

        ActionSaveMovimentCaseReturn({commit}, value) {
            commit('saveMovimentReturn', value);
        },

        ActionUpdateMenu({commit}, name, isCompany = false) {
            if (document.getElementsByClassName('active-page-link')[0]) {
                document.getElementsByClassName('active-page-link')[0].classList.remove('active-page-link');
            }

            document.getElementById(name).classList.add('active-page-link');
            commit('updateIsCompany', isCompany);
        },

        async ActionCheckAllotments({commit}, companyId) {
            await Allotments.listForMenu(companyId).then(async resp => {
               await commit('listAllotments', resp.data)
                commit('checkAllotments', resp.data.validations ? false : true);
            });
            Allotments.listForMenuOnlyUserAllo(companyId).then(resp => {
                commit('listAllotmentsOnlyUserAllo', resp.data)
            });
        },

        ActionCloseSidMenuPhoneMod({commit, state}) {
            if (state.toggled) {
                document.getElementById('wrapper').classList.remove('toggled');
                document.getElementById('configSubmenu').classList.remove('show');

                commit('toggleSidebar');
            }
        },

        ActionCloseModalsToLogin() {
            if (document.getElementById('closeModal')) {
                document.getElementById('closeModal').click();
            } else if (document.getElementById('closeX')) {
                document.getElementById('closeX').click();
            } else if (document.getElementById('closeProfile')) {
                document.getElementById('closeProfile').click();
            }
        }
    },
    mutations: {
        changeMinutesForExpiration(state, val){
            state.minutesForExpiration = val;
        },
        setItemsValidations(state, data){
            state.itemsValidations = data;
            state.itemsValidationsRequired = data.filter(i => i.is_required);
        },
        listAllotments(state, allotments) {
            state.allotmentLoad = true;
            if (!allotments.validations) {
                state.allotments = allotments;
                state.hastwoAllotments = allotments.length == 1 ? false : true;
            }
        },

        listAllotmentsOnlyUserAllo(state, allotments) {
            if (!allotments.validations) {
                state.allotmentsOnlyUserAllo = allotments;
            }else {
                state.allotmentsOnlyUserAllo = null;
            }
        },

        startLopLots(state, companyId = null) {
            let time;

            state.loopLots = setInterval(() => {

                time = new Date();
                let time2 = new Date(time.valueOf() - time.getTimezoneOffset() * 60000);
                time = time2.toISOString().slice(0, 19).replace('T', ' ');

                if (companyId) {
                    let allotment_id = localStorage.getItem('publicAllotmentId');
                    Public.LotListModified(companyId, time, allotment_id).then(resp => {
                        state.lotModified = resp.data;
                    })
                } else {
                    let allotment_id = localStorage.getItem('allotmentId');
                    if (!allotment_id) {
                        allotment_id = state.allotments[0].id
                    }
                    Lots.listModified(time, allotment_id).then(resp => {
                        state.lotModified = resp.data;
                    })
                }

            }, process.env.VUE_APP_LOOP_TIME_LOTS);
        },

        stopLopLots(state) {
            clearInterval(state.loopLots);
        },

        checkAllotments(state, boolean) {
            state.hasAllotments = boolean;
        },

        enableReauthorization(state, number) {
            state.showReahtorizationAlert = number;
        },
        DateNow(state, date) {
            state.dateNow = date;
        },
        disbleModalBeforeFive(state) {
            state.disableBeforeFive = localStorage.getItem('disable_before_five');
        },

        alterSaleValue(state, payload) {
            state.sale = payload;
        },

        saveMovimentReturn(state, payload) {
            state.savedMoviments = payload;
        },

        selectedClients(state, payload) {
            state.selectedClients = payload;
        },

        disbleModalBeforeOne(state) {
            state.disableBeforeOne = localStorage.getItem('disable_before_one');
        },

        resetExpirationTime(state) {
            state.expirationTime = jwt_decode(localStorage.getItem('access_token')).exp;
            let expirationTimeFive = new Date(state.expirationTime * 1000);
            let expirationTimeOne = new Date(state.expirationTime * 1000);
            expirationTimeFive.setMinutes(expirationTimeFive.getMinutes() - 6)
            expirationTimeOne.setMinutes(expirationTimeOne.getMinutes() - 1)
            state.fiveToExpire = expirationTimeFive.getTime() / 1000;
            state.oneToExpire = expirationTimeOne.getTime() / 1000;
        },

        updateIsCompany(state, value) {
            state.isCompany = value;
        },

        displayMenssageAllotmentRequired(state) {
            state.menssageAllotmentRequired = true;
        },

        pinSidebar(state) {
            state.pinned = !state.pinned;
        },

        toggleSidebar(state) {
            state.toggled = state.toggled == null ? true : !state.toggled;
        },

        startCompaniesToken(state) {
            state.companies = JSON.parse(localStorage.getItem('companies'));
        },

        showModalSelectCompany(state, boolean) {
            state.showModal = boolean;
        },

        setImage(state, image) {
            state.image = image;
        },

        setImageCropped(state, image) {
            state.imageCropped = image;
        },

        changeLoading(state, boolean) {
            state.isLoading = boolean;
        },
        setItemId (state, id) {
            state.itemId = id
        }
    }
});

const setBearerToken = token => {
    httpAuth.defaults.headers.authorization = `Bearer ${token}`;
    http.defaults.headers.authorization = `Bearer ${token}`;
    http.defaults.headers.common['company-id'] = localStorage.getItem('companyId');
}

export default stores;
